import { InspectionCase } from './inspection-case.dto';

export enum FloorDoorState {
  Closed = 'סגור',
  // Open = 'פתוח',
  Open_45_Angle = 'פתוח 45°',
  Open_90_Angle = 'פתוח 90°'
}

export enum PressureSystemType {
  Corridor = `לחץ במסדרון מילוט מעל 50 מ'`,
  Stairway = `לחץ בחדרי מדרגות`
}

export class FloorDto extends InspectionCase {
  doorState?: FloorDoorState;
  floorNumber?: string;
  doorOpeningPower?: {
    messured?: number;
    max?: number;
  };
  airFlowSpeed?: {
    messured?: number;
    min?: number;
  };
  differentialPressure?: {
    messured?: number;
    min?: number;
  };
}

export class Floor extends FloorDto {
  constructor(
    data: FloorDto = {
      isApplicable: true,
      doorState: FloorDoorState.Closed
    }
  ) {
    super(data);
    this.floorNumber = data.floorNumber;
    this.doorState = data.doorState ?? FloorDoorState.Closed;
    this.doorOpeningPower = data.doorOpeningPower ?? {};
    this.airFlowSpeed = data.airFlowSpeed ?? {};
    this.differentialPressure = data.differentialPressure ?? {};
  }
}

export class StairsRoomDto {
  type: PressureSystemType;
  closedDoorsStairsName?: string;
  openDoorsStairsName?: string;
  withSprinklers?: boolean;
  closedDoorsFloors?: FloorDto[];
  openDoorsFloors?: FloorDto[];
}

export class StairsRoom extends StairsRoomDto {
  constructor(
    data: StairsRoomDto = {
      type: PressureSystemType.Stairway,
      closedDoorsFloors: [],
      openDoorsFloors: [],
      withSprinklers: false
    }
  ) {
    super();
    this.type = data.type;
    this.closedDoorsStairsName = data.closedDoorsStairsName;
    this.openDoorsStairsName = data.openDoorsStairsName;
    this.withSprinklers = data.withSprinklers;
    this.closedDoorsFloors = data.closedDoorsFloors.map(
      (floor) => new Floor(floor)
    );
    this.openDoorsFloors = data.openDoorsFloors.map(
      (floor) => new Floor(floor)
    );
  }
}
